/**
 * In-progress (creation-draft) card, shared by the Sites list and the Tests
 * list. Domain-agnostic: the host passes the label, a Resume handler (reopen
 * the CreateFlow at the right place), and a Discard handler. Reuses the
 * existing .aero-test-card shell so it sits natively in either grid.
 *
 * The whole card body is the Resume affordance; Discard is a separate ghost
 * button that stops propagation so it never triggers Resume.
 */
import React from 'react';

function DraftCard({ title, subtitle, updatedLabel, onResume, onDiscard, discarding }) {
  return (
    <div
      className="aero-test-card aero-draft-card"
      onClick={onResume}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onResume();
        }
      }}
    >
      <div className="aero-test-card-head">
        <span className="aero-tag aero-tag-amber aero-tag-dot">Draft</span>
        <button
          type="button"
          className="aero-btn aero-btn-ghost aero-btn-sm aero-draft-discard"
          onClick={(e) => {
            e.stopPropagation();
            onDiscard();
          }}
          disabled={discarding}
        >
          {discarding ? 'Discarding…' : 'Discard'}
        </button>
      </div>

      <div>
        <h3 className="aero-test-card-title">{title}</h3>
        <span className="aero-test-card-meta">{subtitle || 'Setup not finished'}</span>
      </div>

      <div className="aero-test-card-foot">
        <span>Updated {updatedLabel}</span>
        <span className="aero-draft-resume">
          Resume
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="9 18 15 12 9 6" />
          </svg>
        </span>
      </div>
    </div>
  );
}

export default DraftCard;
